import type { Warehouse } from "@estelle/domain";

/**
 * Whether a warehouse is mirrored from a channel location at all.
 *
 * `Warehouse` extends `Mirrored`, so `externalId` is typed as always
 * present — but FR-WHS-4 describes a warehouse with no location mapping as
 * a real state ("marked Draft, no stock figures"), so this treats an empty
 * string as that state rather than assuming the type guarantees away the
 * case the requirement exists for.
 */
export function isMapped(warehouse: Warehouse): boolean {
  return warehouse.externalId !== "";
}

/**
 * How many of a page of warehouses have no channel location mapped.
 *
 * Used for the list banner in `WarehouseList` — a count computed once
 * against the same page the table already fetched, rather than a second
 * query for a number the page's own rows already carry.
 */
export function countUnmapped(warehouses: readonly Warehouse[]): number {
  return warehouses.filter((warehouse) => !isMapped(warehouse)).length;
}
